import { InputProps, SelectInput } from "react-admin"
import { ProductClassChoices } from "../../billing_constants"

export const ProductClassInput: React.FC<InputProps> = (props) => (
  <SelectInput label="Product class" choices={ProductClassChoices} {...props} />
)
